/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Modal, Button, Spinner } from "react-bootstrap";
import { Trash, PencilSimpleLine } from "@phosphor-icons/react";
import api from "../../utils/api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import permissions from "../Permissions/permissions1";
import ContentLoader from "react-content-loader";

const Course = () => {
  const [fetchedData, setFetchedData] = useState([]);
  const [show, setShow] = useState(false);
  const [courseName, setCourseName] = useState("");
  const [modules, setModules] = useState([]); // To hold modules for selection
  const [selectedModule, setSelectedModule] = useState(""); // To hold the selected module
  const [ID, setID] = useState(null);
  const [loading, setLoading] = useState(false);
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Customize the number of items per page
  const [totalItems, setTotalItems] = useState(0);
  const [buttonText, setButtonText] = useState("Add Course");
  const [userPermissions, setUserPermissions] = useState({});

  const TableLoader = ({ rows = 5, columns = 4 }) => (
    <tbody>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={rowIndex}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <td key={colIndex} className="text-center">
              <div
                style={{
                  height: "20px",
                  backgroundColor: "#e0e0e0",
                  borderRadius: "20px",
                  width: colIndex === 0 ? "20%" : "70%", // Adjust column widths dynamically
                }}
              ></div>
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );

  useEffect(() => {
    auth();
  }, []);

  async function auth() {
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const role = localStorage.getItem("role");
      const token = localStorage.getItem("authToken");
      const programType = "getPagePermission";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("role", role);
      fd.append("programType", programType);
      fd.append("limit", itemsPerPage);
      fd.append("pageNo", 2);

      const response = await api.post("user/userCurl", fd);
      // console.log("AUTH:", response.data.data[0]);

      if (response.data && response.data.data.length > 0) {
        setUserPermissions(response.data.data[0]); // Store permission data
      }
    } catch (error) {
      // console.error("Error fetching permissions:", error);
      setUserPermissions({});
      toast.error("Error fetching permissions.");
    } finally {
      setLoading(false);
    }
  }

  async function fetchModules() {
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getAllDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const modulesResponse = await api.post("module/moduleCurl", fd);
      // // console.log("Modules Response:", modulesResponse.data);

      if (Array.isArray(modulesResponse.data.getResponse)) {
        setModules(modulesResponse.data.getResponse);
      } else {
        setModules([]);
      }
    } catch (error) {
      // // console.error("Error fetching data:", error);
      setModules([]);
    } finally {
      setLoading(false);
    }
  }

  // Fetch modules and courses data
  async function fetchData(page = 1) {
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getCourseDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("page", page);
      fd.append("limit", itemsPerPage);

      // Fetch course details
      const response = await api.post("course/courseCurl", fd);
      // // console.log("Course Response:", response.data);

      if (response.data && Array.isArray(response.data.getCourseDetails)) {
        setFetchedData(response.data.getCourseDetails);
        setCurrentPage(page);
        setTotalItems(response.data.totalPages * itemsPerPage); // Derive totalItems from totalPages
      } else {
        setFetchedData([]);
        setTotalItems(0);
      }

      await fetchModules(); // Call the fetchModules function
    } catch (error) {
      setFetchedData([]);
      setTotalItems(0);
      toast.error("Error fetching data.");
    } finally {
      setLoading(false);
    }
  }

  // Handle course submission (add or update)
  async function handleSubmit(e) {
    e.preventDefault();

    setLoading(true);
    setButtonText(ID ? "Updating..." : "Adding..."); // Change button text
    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = ID ? "updateCourse" : "addCourse"; // Different action for update or add

    const fd = new FormData();
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);

    fd.append("module", selectedModule); // Send the selected module ID
    fd.append("courseName", courseName); // Send the course name

    // Only append 'id' if it exists (for updating)
    if (ID) {
      fd.append("id", ID);
    }

    // Log FormData to check its contents before s

    try {
      const response = await api.post("course/courseCurl", fd);
      // // console.log(response); // Log the full response to check for issues

      if (response.data.status === true) {
        toast.success(response.data.data); // Display message in toaster
        fetchData(); // Refresh the data after submitting the form
        setShow(false); // Close the modal
        setCourseName(""); // Reset the module name input
        setSelectedModule("");
        setID(null); // Reset the ID after the action
      } else {
        toast.error(response.data.data);
      }

      // Refresh the data after submitting the form
    } catch (error) {
      // // console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
      setButtonText("Add Course"); // Reset button text after submission
    }
  }

  // Open modal to add a new course
  const handleShowAdd = () => {
    setCourseName("");
    setButtonText("Add Course"); // Ensure correct button text
    setSelectedModule(""); // Reset selected module
    setID(null); // No ID for new course
    setShow(true); // Open modal
  };

  // Open modal to edit an existing course
  async function handleShowEdit(course) {
    setLoading(false);
    setButtonText("Update Class"); // Set button text to "Update Class" when editing
    // // console.log("Course to edit:", course.id);
    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = "getDetailsForUpdate";

    const fd = new FormData();
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("id", course.id);

    try {
      const response = await api.post("course/courseCurl", fd);
      // // console.log("Response from API:", response);

      if (response.data && response.data.getCourseDetails) {
        const courseDetails = response.data.getCourseDetails[0]; // Assuming the response is an array of chapter details
        // Prefill the form fields
        setCourseName(courseDetails.courseName);
        setSelectedModule(courseDetails.moduleId);
        // Make sure this is set
        setID(courseDetails.id); // Set ID for editing
        setShow(true); // Show the modal
      }
    } catch (error) {
      // // console.error("Error fetching chapter details:", error);
    }
  }

  // Close modal
  const handleClose = () => {
    setShow(false);
    setCourseName(""); // Reset the form data
    setID(null); // Reset ID
  };

  // Pagination logic
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchData(page);
    }
  };

  // Fetch the data when the component mounts
  useEffect(() => {
    fetchData();
  }, []);

  // Delete course functionality
  // Handle module deletion
  async function handleDelete(id) {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "deleteCourse";

      const fd = new FormData();
      fd.append("programType", programType);
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("id", id);

      const response = await api.post("course/courseCurl", fd);
      toast.success("Course deleted successfully");
      if (response.data && response.data.message) {
        toast.success("Course deleted successfully");
        // // console.log(response.data.message);
      } else {
        // // console.error("Failed to delete the module. Response:", response);
      }

      // Refresh the data after deletion
      fetchData(); // This will update the list of courses
    } catch (error) {
      // // console.error("Error deleting module:", error);
    }
  }
  const mystyle = {
    marginTop: "20px",
    display: "flex",
    justifyContent: "space-between",
  };
  const mystyle1 = {
    marginTop: "15px",
  };

  const createPagination = () => {
    const pageNumbers = [];
    const range = 2; // Number of pages to display around the current page
    const maxPageNumber = totalPages;

    // Always include the first page
    pageNumbers.push(1);

    // Add an ellipsis if there is a gap between the first page and the visible range
    if (currentPage > range + 2) {
      pageNumbers.push("...");
    }

    // Add pages around the current page
    for (
      let i = Math.max(currentPage - range, 2);
      i <= Math.min(currentPage + range, maxPageNumber - 1);
      i++
    ) {
      pageNumbers.push(i);
    }

    // Add an ellipsis if there is a gap before the last page
    if (currentPage < maxPageNumber - range - 1) {
      pageNumbers.push("...");
    }

    // Always include the last page
    if (maxPageNumber > 1) {
      pageNumbers.push(maxPageNumber);
    }

    return pageNumbers;
  };

  return (
    <div className="dashboard-body">
      {userPermissions.is_view === "0" ? (
        <div className="text-center mt-5">
          <h4 className="text-danger">Permission Denied</h4>
        </div>
      ) : (
        <>
          {/* Breadcrumb */}
          <div className="breadcrumb-with-buttons mb-24 flex-between flex-wrap gap-8">
            <div className="breadcrumb mb-24">
              <ul className="flex-align gap-4">
                <li>
                  <Link
                    to="/"
                    className="text-gray-200 fw-normal text-15 hover-text-main-600"
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <span className="text-gray-500 fw-normal d-flex">
                    <i className="ph ph-caret-right"></i>
                  </span>
                </li>
                <li>
                  <span className="text-main-600 fw-normal text-15">
                    Course
                  </span>
                </li>
              </ul>
            </div>

            <div className="flex-align gap-8 flex-wrap">
              <div className="flex-align gap-8 flex-wrap">
                {/* <div class="position-relative text-gray-500 flex-align gap-4 text-13">
              <span class="text-inherit">Sort by: </span>
              <div class="flex-align text-gray-500 text-13 border border-gray-100 rounded-4 ps-20 focus-border-main-600 bg-white">
                <span class="text-lg">
                  <i class="ph ph-funnel-simple"></i>
                </span>
                <select class="form-control  mb-5 border-0 text-inherit rounded-4 text-center">
                  <option value="1" selected>
                    Popular
                  </option>
                  <option value="1">Latest</option>
                  <option value="1">Trending</option>
                  <option value="1">Matches</option>
                </select>
              </div>
            </div>
            <div class="flex-align text-gray-500 text-13 border border-gray-100 rounded-4 ps-20 focus-border-main-600 bg-white">
              <span class="text-lg">
                <i class="ph ph-layout"></i>
              </span>
              <select
                class="form-control mb-5 border-0 text-inherit rounded-4 text-center"
                id="exportOptions"
              >
                <option value="" selected disabled>
                  Export
                </option>
                <option value="csv">CSV</option>
                <option value="json">JSON</option>
              </select>
            </div> */}
                {/* Show Add Button Only if User Has Permission */}
                {userPermissions.is_add === "1" && (
                  <button
                    onClick={handleShowAdd}
                    className="btn btn-lg btn-main mt-0 "
                  >
                    <i class="ph ph-plus-square"></i>   Add Course
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Modules Table */}
          <div className="card mt-24">
            <div
              className="card-header  table-responsive "
              style={{ padding: "10px" }}
            >
              <table
                id="assignmentTable"
                className="table table-striped "
              >
                <thead  style={{borderBottom:"1px #D5DBE7 solid"}}>
                  <tr>
                    <th className="h5 text-gray-300" scope="col">
                      ID
                    </th>
                    <th className="h5 text-gray-300" scope="col">
                      Class Name
                    </th>
                    <th className="h5 text-gray-300" scope="col">
                      Course Name
                    </th>
                    {(userPermissions.is_edit === "1" ||
                      userPermissions.is_delete === "1") && (
                      <th className="h5 text-gray-300" scope="col">
                        Action
                      </th>
                    )}
                  </tr>
                </thead>
                {loading ? (
                  <TableLoader rows={5} columns={4} /> // Show custom loader
                ) : (
                  <tbody>
                    {permissions.courseList ? (
                      <>
                        {fetchedData.map((course, index) => (
                          <tr key={course.id}>
                            <td className="h6 mb-0 fw-medium text-gray-300">
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </td>
                            <td className="h6 mb-0 fw-medium text-gray-300">
                              {course.moduleName}
                            </td>
                            <td className="h6 mb-0 fw-medium text-gray-300">
                              {course.courseName}
                            </td>
                            <td className="g-2">
                              {/* Show Add Button Only if User Has Permission */}
                              {userPermissions.is_edit === "1" && (
                                <button onClick={() => handleShowEdit(course)}>
                                  <PencilSimpleLine size={22} color="#00945b" />
                                </button>
                              )}
                              &nbsp; &nbsp;
                              {userPermissions.is_delete === "1" && (
                                <button onClick={() => handleDelete(course.id)}>
                                  <Trash size={22} color="#c70000" />
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center text-danger">
                          Permission Denied !
                        </td>
                      </tr>
                    )}
                  </tbody>
                )}
              </table>
            </div>
             {/* Pagination */}
             <div>
              {loading ? (
                <div className="d-flex justify-content-end">
                  <ContentLoader
                    speed={2}
                    width={200} // Adjusted width to fit the right alignment
                    height={50}
                    viewBox="0 0 200 50"
                    backgroundColor="#e0e0e0"
                    foregroundColor="#f5f5f5"
                  >
                    {/* Simulating loading pagination buttons */}
                    <rect x="0" y="10" rx="5" ry="5" width="40" height="30" />
                    <rect x="50" y="10" rx="5" ry="5" width="40" height="30" />
                    <rect x="100" y="10" rx="5" ry="5" width="40" height="30" />
                    <rect x="150" y="10" rx="5" ry="5" width="40" height="30" />
                  </ContentLoader>
                </div>
              ) : (
                fetchedData.length > 0 && (
                  <div>
                    <div
                      className="card-footer d-flex justify-content-end flex-wrap"
                      style={{ backgroundColor: "" }}
                    >
                      <ul className="pagination flex-align flex-wrap">
                        {createPagination().map((page, index) => (
                          <li
                            key={index}
                            className={`page-item ${
                              currentPage === page ? "active" : ""
                            }`}
                          >
                            {page === "..." ? (
                              <button
                                className="page-link h-32 w-32 flex-center text-15 rounded-8 fw-medium"
                                style={{ backgroundColor: "white" }}
                              >
                                <span className="page-link">...</span>
                              </button>
                            ) : (
                              <button
                                className="page-link h-32 w-32 flex-center text-15 rounded-8 fw-medium"
                                style={{ backgroundColor: "white" }}
                                onClick={() => handlePageChange(page)}
                              >
                                {page}
                              </button>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        </>
      )}

      <ToastContainer />

      {/* Modal for adding/editing modules */}
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>{ID ? "Edit Course" : "Add New Course"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit} id="course-form">
            <div className="" style={mystyle1}>
              <label htmlFor="moduleName" className="form-label mb-8 h6">
                Select Class <span style={{ color: "red" }}>*</span>
              </label>
              <select
                className="form-control fw-medium"
                value={selectedModule}
                onChange={(e) => {
                  setSelectedModule(e.target.value);
                  // // console.log("Selected Module ID:", e.target.value); // Check the selected module ID
                }}
              >
                <option value="">Select a Class</option>
                {modules.map((module) => (
                  <option key={module.id} value={module.id}>
                    {module.moduleName}
                  </option>
                ))}
              </select>
            </div>

            <div className="" style={mystyle1}>
              <label htmlFor="courseName" className="form-label mb-8 h6">
                Course Name <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className="form-control fw-medium"
                placeholder="Enter course name"
                id="courseName"
                name="courseName"
                value={courseName}
                onChange={(e) => setCourseName(e.target.value)}
                required
              />
            </div>
            <div style={mystyle}></div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-outline-main bg-main-100 border-main-100 text-main-600 rounded-pill py-9"
            variant="secondary"
            onClick={handleClose}
          >
            Cancel
          </Button>

          <Button
            className="btn btn-outline-main bg-main-100 border-main-100 text-main-600 rounded-pill py-9"
            variant="primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />{" "}
                {buttonText}
              </>
            ) : (
              buttonText
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Course;
